export default __webpack_public_path__ + "services.webp";